export enum Module {
    BACK_OFFICE,
    CRM_CORE,
    DOCUMENT_REPOSITORY,
}
